import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import ConfigurationApiService from '@lib/api-services/ConfigurationAPIService';
import ProjectApiService from '@lib/api-services/ProjectApiService';
import buildResourcePath from '@lib/buildResourcePath';
import UIServicesRegistry from '@lib/ui-services/UIServicesRegistry';
import XMessageUIService from '@lib/ui-services/XMessageUIService';
import {observer} from 'mobx-react';
import React from 'react';
import ProjectStore from '../../store/projectStore';
import Button from '../common/Button';
import IndexTableFeature from '../index-table/IndexTableFeature';
import AddConfigurationDropdown from './AddConfigurationDropdown';
import AddExistingConfigurationModal from './AddExistingConfigurationModal';
import ProjectConfigurationsIndexTable from './ProjectConfigurationsIndexTable';
import ValueFormatter from '../utils/ValueFormatter';
import Loader from '../common/Loader';

const ProjectConfigurations = observer(
    class ProjectConfigurations extends React.Component {

        state = {
            manuallyChangedRows: {},
            manuallyAddedRows: [],
            deleteModalIsOpen: false
        }

        constructor(props) {
            super(props)
            this.summaryRef = React.createRef()
            this.tableRef = React.createRef()

            this.addConfigurationOptions = [
                {id: 0, label: __('Add new configuration')},
                {id: 1, label: __('Add existing configuration')}
            ]

            scheduleAtDocumentReady(() => {
                this.xMessageUIService = UIServicesRegistry.getService(XMessageUIService)
                this.configurationApiService = APIServicesRegistry.getService(ConfigurationApiService)
                this.projectApiService = APIServicesRegistry.getService(ProjectApiService)
                this.stepAboutToBecomeVisible()
            })
        }

        addConfigurationOptionClick = option => {
            if (option.id === 0) {
                this.addNewConfigurationClick()
            }

            if (option.id === 1) {
                ProjectStore.setAddExistingConfigurationModalVisible(true)
            }
        }

        addNewConfigurationClick() {
            if (ProjectStore.isNew()) {
                this.xMessageUIService.pushNotification({
                    type: 'info',
                    title: __('Info'),
                    text: __('Before adding new configuration you must save project.'),
                    timeout: 5
                });
            } else {
                window.location.href = buildResourcePath(`Project/CreateConfiguration?projectId=${ProjectStore.formModel.id.value}`)
            }
        }

        onRemoveRowClick = (guid) => {
            let manuallyChangedRows = this.state.manuallyChangedRows;
            var item = ProjectStore.formModel.configurations.items.find(x => x.guid === guid);
            delete manuallyChangedRows[item.id];

            var items = ProjectStore.formModel.configurations.items.filter(x => x.guid !== guid);
            var model = ProjectStore.getTransformedFormModel()

            this.calculatePrices({items: items, summary: model.summary})

            this.setState({
                manuallyChangedRows: manuallyChangedRows
            })
        }

        copyRow(guid, requestAction) {
            var model = ProjectStore.getTransformedFormModel()
            var data = {
                guid: guid,
                projectId: ProjectStore.formModel.id.value,
                items: model.configurations,
                summary: model.summary
            }

            this.projectApiService[requestAction](data).then(response => {
                if (!response.data) {
                    ProjectStore.setConfigurationIsValid(false);
                    ProjectStore.duringEditConfigurations = false;
                    return;
                }

                if (response.data.items.items.length)
                    ProjectStore.setDirty(true);

                ProjectStore.updateConfigurationItems(response.data.items.items);
                ProjectStore.updateConfigurationSummary(response.data.summary);
                ProjectStore.duringEditConfigurations = false;
            })
        }

        onCopyRowClick = (guid) => {
            this.copyRow(guid, 'copyConfiguration');
        }

        onCopyAsOptionalRowClick = (guid) => {
            this.copyRow(guid, 'copyConfigurationAsOptional');
        }

        onRootCheckboxToggled = manuallyChangedRows => {
            this.setState({
                manuallyChangedRows
            })
        }

        onRowCheckboxToggled = manuallyChangedRows => {
            this.setState({
                manuallyChangedRows
            })
        }

        renderEditFactoryDiscountButton = () => {
            var color = Button.Color.Gray
            var label = 'Edit factory discount'
            var onClick = () => ProjectStore.setFactoryDiscountDuringEdit(true)

            if (ProjectStore.factoryDiscountDuringEdit) {
                color = Button.Color.Default
                label = 'Save factory discount'
                onClick = () => ProjectStore.setFactoryDiscountDuringEdit(false)
            }

            if (!ProjectStore.configurationIsValid) {
                color = Button.Color.Gray
                onClick = () => {
                }
            }

            return <Button color={color} onClick={onClick}>{__(label)}</Button>
        }

        renderEditDiscountButton = () => {
            var color = Button.Color.Gray
            var label = 'Edit discount'
            var onClick = () => ProjectStore.setDiscountsDuringEdit(true)

            if (ProjectStore.discountsDuringEdit) {
                color = Button.Color.Default
                label = 'Save discount'
                onClick = () => ProjectStore.setDiscountsDuringEdit(false)
            }

            if (!ProjectStore.configurationIsValid) {
                color = Button.Color.Gray
                onClick = () => {
                }
            }

            return <Button color={color} onClick={onClick}>{__(label)}</Button>
        }

        onConfiguratioRowPriceChanged = (name, guid, value) => {
            var items = ProjectStore.formModel.configurations.items.toJS();
            var index = items.findIndex(x => x.guid === guid);
            items[index][name] = value;

            var model = ProjectStore.getTransformedFormModel()
            this.calculatePrices({propertyChanged: name, items: items, summary: model.summary})
        }

        calculatePrices(data) {
            data.projectId = ProjectStore.formModel.id.value

            this.projectApiService.calculateConfigurationsPrices(data).then(response => {
                if (!response.data) {
                    ProjectStore.setConfigurationIsValid(false)
                    return;
                }

                ProjectStore.setConfigurationIsValid(true);
                ProjectStore.updateConfigurationItems(response.data.items.items)
                ProjectStore.updateConfigurationSummary(response.data.summary)
                ProjectStore.setDirty(true);
            })
        }

        onProjectDiscountChange(value) {
            if (ProjectStore.formModel.summary.projectDiscountValue)
                ProjectStore.formModel.summary.projectDiscountValue.value = value
            else
                ProjectStore.formModel.summary.ProjectDiscountValue.value = value

            var model = ProjectStore.getTransformedFormModel()

            this.calculatePrices({items: model.configurations, summary: model.summary});
        }

        onProductSerialNumberChanged = (row, productSerialNumber) => {
            ProjectStore.setProductSerialNumber(row.guid, productSerialNumber);
        }

        onOptionSelectClick = (row) => {
            if (row.optionState === 2) {
                return;
            }

            var items = ProjectStore.formModel.configurations.items.toJS();
            items.filter(x => x.optionGroupGuid === row.optionGroupGuid).forEach(x => x.optionState = 0);
            var index = items.findIndex(x => x.guid === row.guid);
            items[index].optionState = 2;
            var model = ProjectStore.getTransformedFormModel()
            this.calculatePrices({items: items, summary: model.summary})
        }

        onOptionGroupNameChange = (optionGroupGuid, text) => {
            var items = ProjectStore.formModel.configurations.items.toJS();
            items.filter(x => x.optionGroupGuid === optionGroupGuid).forEach(x => x.optionGroupName = text);
        }

        onFactoryDiscountChange(value) {
            ProjectStore.formModel.summary.factoryDiscountValue.value = value
            var model = ProjectStore.getTransformedFormModel()
            this.calculatePrices({items: model.configurations, summary: model.summary});
        }

        render() {
            let columns = ProjectStore.formModel.configurations.columns;
            let items = ProjectStore.formModel.configurations.items.toJS();
            let options = {
                rowButtons: ProjectStore.formModel.configurations.rowButtons.toJS(),
                onConfiguratioRowPriceChanged: this.onConfiguratioRowPriceChanged,
                onProductSerialNumberChanged: this.onProductSerialNumberChanged,
                onOptionSelectClick: this.onOptionSelectClick,
                onOptionGroupNameChange: this.onOptionGroupNameChange
            }

            const getIndexTableProps = () => {

                var props = {
                    projectId: ProjectStore.formModel.id.value,
                    results: items,
                    columns: columns,
                    options: options,
                    onRemoveRowClick: this.onRemoveRowClick,
                    canSetConfigurationOptional: this.props.canSetConfigurationOptional,
                    onCopyRowClick: this.onCopyRowClick,
                    onCopyAsOptionalRowClick: this.onCopyAsOptionalRowClick,
                    features: []
                }

                if (options.rowButtons.some(x => x.slug === 'Edit')) {
                    props.features.push(IndexTableFeature.NamesAsEditPageLinks);
                }
                if (options.rowButtons.some(x => x.slug === 'Edit') && options.rowButtons.length > 1) {
                    props.features.push(IndexTableFeature.ActionButtons);
                }

                return props;
            }

            return (
                <div style={{position: 'relative'}}>
                    {ProjectStore.duringEditConfigurations && <Loader fillContainer={true}/>}
                    <div className="project-configurations-section flex-center-v flex-space-between">
                        <h3>{__('Configurations')}</h3>

                        <div className="add-configuration-options page-body-action-buttons">
                            {this.props.canEditDiscount && this.renderEditDiscountButton()}
                            {this.props.canEditFactoryCostDiscount && this.renderEditFactoryDiscountButton()}

                            <span className="desktop-only">
                                    {this.props.canAddConfiguration && <AddConfigurationDropdown
                                        items={this.addConfigurationOptions}
                                        caption={__('Add configuration')}
                                        onItemClick={this.addConfigurationOptionClick}
                                    />}
                                </span>
                        </div>
                    </div>

                    {ProjectStore.formModel.configurations.items.length > 0 && (
                        <React.Fragment>
                            <div className="project-configurations-table responsive-table-container"
                                 ref={this.tableRef}>
                                <ProjectConfigurationsIndexTable {...getIndexTableProps()} />
                            </div>
                            {this.renderSummary()}
                        </React.Fragment>
                    )}

                    <AddExistingConfigurationModal/>
                </div>
            );
        }

        areFooterActionButtonsDisabled() {
            return Object.entries(this.state.manuallyChangedRows).filter(([k, v]) => v === true).length === 0
        }

        renderDiscount() {
            if (ProjectStore.discountsDuringEdit) {
                var property = ProjectStore.formModel.summary.projectDiscountValue || ProjectStore.formModel.summary.ProjectDiscountValue //todo
                return <input
                    type="text"
                    pattern="\d*"
                    defaultValue={property.value}
                    onChange={e => {
                        e.target.value = ValueFormatter.decimal(e.target.value, property.value)
                        this.onProjectDiscountChange(Number(e.target.value).toFixed(2))
                    }}
                />
            }
            var value = ProjectStore.formModel.summary.projectDiscount || ProjectStore.formModel.summary.ProjectDiscount
            return <React.Fragment>{value.value}</React.Fragment>
        }

        renderFactoryDiscount() {
            if (ProjectStore.factoryDiscountDuringEdit) {
                var property = ProjectStore.formModel.summary.factoryDiscountValue;
                return <input
                    type="text"
                    pattern="\d*"
                    defaultValue={property.value}
                    onChange={e => {
                        e.target.value = ValueFormatter.decimal(e.target.value, property.value)
                        this.onFactoryDiscountChange(Number(e.target.value).toFixed(2));
                    }}
                />
            }
            var value = ProjectStore.formModel.summary.factoryDiscount;
            return <React.Fragment>{value.value}</React.Fragment>
        }

        renderSummary() {
            let {
                final,
                totalPrice,
                factoryDiscount,
                totalFactoryCost,
                totalMargin,
                projectDiscount
            } = ProjectStore.formModel.summary
            this.stepAboutToBecomeVisible()

            var className = 'configuration-editor-pricing-summary';
            if (!totalPrice.visible) {
                className += ' without-discounts'
            }

            return (
                <div className={className} ref={this.summaryRef}>
                    {final.visible && <div className="configuration-editor-pricing-summary-item">
                        <span>{__('Total price')}</span>
                        <span>{final.value}</span>
                    </div>}
                    {projectDiscount.visible && <div className="configuration-editor-pricing-summary-item">
                        <span>{__('Project discount')}</span>
                        <span>{this.renderDiscount()}</span>
                    </div>}
                    {totalPrice.visible && <div className="configuration-editor-pricing-summary-item">
                        <span>{__('Before project discount')}</span>
                        <span>{totalPrice.value}</span>
                    </div>}
                    {factoryDiscount.visible && <div className="configuration-editor-pricing-summary-item">
                        <span>{__('Total factory discount')}</span>
                        <span>{this.renderFactoryDiscount()}</span>
                    </div>}
                    {totalFactoryCost.visible && <div className="configuration-editor-pricing-summary-item">
                        <span>{__('Total factory cost')}</span>
                        <span>{totalFactoryCost.value}</span>
                    </div>}
                    {totalMargin.visible && <div className="configuration-editor-pricing-summary-item">
                        <span>{__('Total margin')}</span>
                        <span>{totalMargin.value}</span>
                    </div>}
                </div>
            )
        }

        stepAboutToBecomeVisible() {
            let summary = this.summaryRef.current
            let table = this.tableRef.current
            if (summary && table && summary.style.opacity !== "1") {
                let finalPriceHeader = table.querySelectorAll('th[slug="Price"]')[0] || table.querySelectorAll('th[slug="FactoryCost"]')[0]

                // Wait for React to render the component.
                setTimeout(() => {

                    // Now wait for the animation to end, because it changes the dimensions.
                    setTimeout(() => {
                        summary.style.position = 'relative'
                        summary.style.left = (finalPriceHeader.offsetLeft - table.offsetLeft) + 'px'
                        $(summary).animate({'opacity': 1}, 100)
                    }, 200)
                })
            }
        }
    }
)

export default ProjectConfigurations;